import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pin_land",
  "use": "icon-pin_land-usage",
  "viewBox": "0 0 24 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 32\" id=\"icon-pin_land\"><path fill=\"#e20036\" d=\"M11.964 3.688c4.562 0 8.26 3.683 8.26 8.228 0 4.544-3.698 8.227-8.26 8.227-4.562 0-8.26-3.683-8.26-8.227 0-4.544 3.698-8.228 8.26-8.228zm0 28.312s11.964-13.503 11.964-20.084C23.928 5.336 18.57 0 11.964 0 5.356 0 0 5.335 0 11.916S11.964 32 11.964 32z\" /><path fill=\"#e20036\" d=\"M6.558 11.916c0-2.974 2.42-5.385 5.406-5.385 2.986 0 5.406 2.41 5.406 5.385 0 2.973-2.42 5.384-5.406 5.384-2.986 0-5.406-2.41-5.406-5.384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol